/* @flow */

export default class CouponFormModel {
  reference: string;

  constructor() {
    this.reference = '';
  }
}
